module.exports = __webpack_public_path__ + "static/media/benedict_croffles.3a5162b3.jpeg";